import httpContext from 'express-http-context';
import {JwtClaim} from '../../auth/JwtClaim.type';
import logger from '../../log/logger';
import {IS_CLIENT_SIDE} from '../shared/utils/constants';
import {PagewebRequestInfo} from './PagewebRequestInfo.interface';

export class RequestContext {
  /**
   * 클라이언트단에선 단일한 컨텍스트가 보장되기 때문에 httpContext 를 사용하지 않고 프로퍼티에 저장합니다.
   * */
  private storageInClient?: PagewebRequestInfo;
  private contextIn: 'Server' | 'Browser';

  constructor() {
    this.contextIn = IS_CLIENT_SIDE ? 'Browser' : 'Server';
  }

  public initializeFromJwt(jwtClaim: JwtClaim) {
    if (!jwtClaim.requestInfo) {
      logger.err('initializeFromJwt: jwtClaim.requestInfo is not found');
      return;
    }
    this.requestInfo = jwtClaim.requestInfo;
  }

  get requestInfo(): PagewebRequestInfo {
    return this.contextIn === 'Server' &&
      process?.env?.JEST_WORKER_ID === undefined
      ? httpContext.get(CONTEXT_REQUEST_INFO_KEY)
      : this.storageInClient!;
  }

  set requestInfo(requestInfo: PagewebRequestInfo) {
    this.contextIn === 'Server' && process?.env?.JEST_WORKER_ID === undefined
      ? httpContext.set(CONTEXT_REQUEST_INFO_KEY, requestInfo)
      : (this.storageInClient = requestInfo);
  }
}

const CONTEXT_REQUEST_INFO_KEY = 'http-context-request-info';

/**
 * 사용자 요청 컨텍스트를 핸들링하는 싱글턴 인스턴스
 * 서버/브라우져 어디서든 호출 가능
 */
export const requestContext = new RequestContext();
